<section class="flex-1 relative overflow-hidden bg-white">
    <div class="max-w-[1400px] mx-auto px-6 py-16 flex flex-col items-center">
        <div class="header-line">
            <h1 class="text-center text-4xl font-bold self-center">
                <span>Hilfe und Kontakt</span>
            </h1>
            <p class="info-text">Hier können Sie eine Anfrage senden.</p>
        </div>
        <div class="form-group">
            <div class="form-control">
                <label>Anfragegrund</label>
                <mat-select [formControl]="header" [errorStateMatcher]="matcher" class="custom-select">
                    <mat-option [value]="''">Bitte wählen</mat-option>
                    <mat-option [value]="'Ich habe eine Frage zum Portal'">Ich habe eine Frage zum Portal
                    </mat-option>
                    <mat-option [value]="'Ich bin Arzt/Ärztin und interessiere mich an einer Kooperation'">Ich
                        bin Arzt/Ärztin und interessiere mich an einer Kooperation
                    </mat-option>
                    <mat-option
                        [value]="'Ich bin Besitzer/Besitzern einer Apotheke und möchte gelistet werden'">Ich bin
                        Besitzer/Besitzern einer Apotheke und möchte gelistet werden
                    </mat-option>
                    <mat-option
                        [value]="'Konto löschen'">
                        Konto löschen
                    </mat-option>
                    <mat-option [value]="'Sonstige Anfrage'">Sonstige Anfrage</mat-option>
                </mat-select>
                @if (header.hasError('required') && !header.untouched) {
                    <mat-error>* Pflichtfeld</mat-error>
                }
            </div>
            <div class="form-control grid! grid-cols-1! lg:grid-cols-2! gap-4 mt-8">
                <div class="col-span-1">
                    <div class="form-control">
                        <label>Vorname</label>
                        <input matInput [formControl]="firstName" placeholder="Vorname"
                               [errorStateMatcher]="matcher">
                        @if (firstName.hasError('required') && !firstName.untouched) {
                            <mat-error>* Pflichtfeld</mat-error>
                        }
                    </div>
                </div>
                <div class="col-span-1">
                    <div class="form-control">
                        <label>Nachname</label>
                        <input matInput [formControl]="lastName" placeholder="Nachname"
                               [errorStateMatcher]="matcher">
                        @if (lastName.hasError('required') && !lastName.untouched) {
                            <mat-error>* Pflichtfeld</mat-error>
                        }
                    </div>
                </div>
            </div>
            <div class="form-control mt-8">
                <label>Ihre E-Mail-Adresse</label>
                <input matInput [formControl]="senderMail" placeholder="mail@example.com"
                       [errorStateMatcher]="matcher">
                <mat-hint>Wir benötigen Ihre E-Mail Adresse, damit wir Ihre Anfrage bearbeiten und Ihnen
                    antworten können.
                </mat-hint>
                @if (senderMail.hasError('required') && !senderMail.untouched) {
                    <mat-error>* Pflichtfeld</mat-error>
                } @else if (senderMail.hasError('email')) {
                    <mat-error>* E-Mail ist ungültig</mat-error>
                }
            </div>
            <div class="form-control mt-8">
                <label>Anfrage</label>
                <textarea matInput [formControl]="reason" rows="8"
                          placeholder="Beschreiben Sie hier Ihr Anliegen."
                          class="min-h-[150px]"
                          [errorStateMatcher]="matcher"></textarea>
                @if (reason.hasError('required') && !reason.untouched) {
                    <mat-error>* Pflichtfeld</mat-error>
                }
            </div>
            <div class="captcha-container grid grid-cols-2  gap-4 mt-8">
                <div class="flex col-span-2 lg:col-span-1">
                    <div class="canvas-container h-30 w-full max-w-52 bg-app-primary-10 rounded-lg">
                        <canvas id="captcha" class="h-full w-full"></canvas>
                    </div>
                    <button class="btn-rounded redo self-center ml-4 lg:ml-8" (click)="reloadCaptcha()">
                        <i class="fa-solid fa-arrows-rotate icon-center"></i>
                    </button>
                </div>
                <div class="form-group self-center col-span-2 lg:col-span-1">
                    <div class="form-control">
                        <label>Bitte geben Sie den Captcha Code ein</label>
                        <input matInput [(ngModel)]="captchaInput" [ngModelOptions]="{standalone: true}"
                               placeholder="Captcha Code" (input)="checkCaptcha()">
                    </div>
                </div>
            </div>
            <div class="flex justify-end">
                <button class="btn primary-button" (click)="sendRequest()">Absenden</button>
            </div>
        </div>
    </div>
</section>
